<!-- Start -->
<section class="relative">
  <div class="container-fluid">
    <div class="grid md:grid-cols-12 gap-[30px]">
      <div class="lg:col-span-12 md:col-span-12">
        <div class="p-6 rounded-md shadow dark:shadow-gray-800 bg-white dark:bg-slate-900">
          <h5 class="text-lg font-semibold mb-4">{{ "SETTINGS.PROFILE.PERSONAL_DETAIL" | translate }}:</h5>
          <form>
            <div class="grid lg:grid-cols-2 grid-cols-1 gap-5">
              <div>
                <label class="form-label font-medium">{{ "SETTINGS.PROFILE.FIRST_NAME" | translate }}: <span class="text-red-600">*</span></label>
                <input type="text" class="form-input w-full text-[15px] py-2 px-3 h-10 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded-full outline-none border border-gray-200 focus:border-violet-600 dark:border-gray-800 dark:focus:border-violet-600 focus:ring-0 mt-2" placeholder="First Name:" id="firstname" name="name" required="">
              </div>
              <div>
                <label class="form-label font-medium">{{ "SETTINGS.PROFILE.LAST_NAME" | translate }}: <span class="text-red-600">*</span></label>
                <input type="text" class="form-input w-full text-[15px] py-2 px-3 h-10 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded-full outline-none border border-gray-200 focus:border-violet-600 dark:border-gray-800 dark:focus:border-violet-600 focus:ring-0 mt-2" placeholder="Last Name:" id="lastname" name="name" required="">
              </div>
              <div>
                <label class="form-label font-medium">{{ "SETTINGS.PROFILE.YOUR_EMAIL" | translate }}</label>
                <input type="email" disabled class="form-input w-full text-[15px] py-2 px-3 h-10 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded-full outline-none border border-gray-200 focus:border-violet-600 dark:border-gray-800 dark:focus:border-violet-600 focus:ring-0 mt-2" name="email" [value]="userEmail">
              </div>
            </div><!--end grid-->

            <input type="submit" id="submit" name="send" class="btn bg-violet-600 hover:bg-violet-700 border-violet-600 hover:border-violet-700 text-white rounded-full mt-5" [value]="'SETTINGS.PROFILE.SAVE_CHANGES' | translate">
          </form><!--end form-->
        </div>

        <div class="p-6 rounded-md shadow dark:shadow-gray-800 bg-white dark:bg-slate-900 mt-[30px]">
          <h5 class="text-lg font-semibold mb-6">{{ "SETTINGS.PROFILE.SOCIAL_PROFILES" | translate }}:</h5>

          <div class="md:flex">
            <div class="md:w-1/3">
              <span class="font-medium">{{ "SETTINGS.PROFILE.TWITTER" | translate }}</span>
            </div>

            <div class="md:w-2/3 mt-4 md:mt-0">
              <form>
                <div class="form-icon relative">
                  <i data-feather="twitter" class="w-4 h-4 absolute top-3 start-4"></i>
                  <input type="text" class="form-input w-full text-[15px] ps-12 py-2 px-3 h-10 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded-full outline-none border border-gray-200 focus:border-violet-600 dark:border-gray-800 dark:focus:border-violet-600 focus:ring-0" [placeholder]="'SETTINGS.PROFILE.TWITTER_PLACEHOLDER' | translate" id="twitter_name" name="name" required="">
                </div>
              </form>

              <p class="text-slate-400 mt-1">{{ "SETTINGS.PROFILE.TWITTER_DESCRIPTION" | translate }}</p>
            </div>
          </div>

          <div class="md:flex mt-8">
            <div class="md:w-1/3">
              <span class="font-medium">{{ "SETTINGS.PROFILE.FACEBOOK" | translate }}</span>
            </div>

            <div class="md:w-2/3 mt-4 md:mt-0">
              <form>
                <div class="form-icon relative">
                  <i data-feather="facebook" class="w-4 h-4 absolute top-3 start-4"></i>
                  <input type="text" class="form-input w-full text-[15px] ps-12 py-2 px-3 h-10 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded-full outline-none border border-gray-200 focus:border-violet-600 dark:border-gray-800 dark:focus:border-violet-600 focus:ring-0" [placeholder]="'SETTINGS.PROFILE.FACEBOOK_PLACEHOLDER' | translate" id="facebook_name" name="name" required="">
                </div>
              </form>

              <p class="text-slate-400 mt-1">{{ "SETTINGS.PROFILE.FACEBOOK_DESCRIPTION" | translate }}</p>
            </div>
          </div>

          <div class="md:flex mt-8">
            <div class="md:w-1/3">
              <span class="font-medium">{{ "SETTINGS.PROFILE.INSTAGRAM" | translate }}</span>
            </div>

            <div class="md:w-2/3 mt-4 md:mt-0">
              <form>
                <div class="form-icon relative">
                  <i data-feather="instagram" class="w-4 h-4 absolute top-3 start-4"></i>
                  <input type="text" class="form-input w-full text-[15px] ps-12 py-2 px-3 h-10 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded-full outline-none border border-gray-200 focus:border-violet-600 dark:border-gray-800 dark:focus:border-violet-600 focus:ring-0" [placeholder]="'SETTINGS.PROFILE.INSTAGRAM_PLACEHOLDER' | translate" id="insta_name" name="name" required="">
                </div>
              </form>

              <p class="text-slate-400 mt-1">{{ "SETTINGS.PROFILE.INSTAGRAM_DESCRIPTION" | translate }}</p>
            </div>
          </div>

          <div class="md:flex mt-8">
            <div class="md:w-1/3">
              <span class="font-medium">{{ "SETTINGS.PROFILE.YOUTUBE" | translate }}</span>
            </div>

            <div class="md:w-2/3 mt-4 md:mt-0">
              <form>
                <div class="form-icon relative">
                  <i data-feather="youtube" class="w-4 h-4 absolute top-3 start-4"></i>
                  <input type="url" class="form-input w-full text-[15px] ps-12 py-2 px-3 h-10 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded-full outline-none border border-gray-200 focus:border-violet-600 dark:border-gray-800 dark:focus:border-violet-600 focus:ring-0" [placeholder]="'SETTINGS.PROFILE.YOUTUBE_PLACEHOLDER' | translate" id="you_url" name="url" required="">
                </div>
              </form>

              <p class="text-slate-400 mt-1">{{ "SETTINGS.PROFILE.YOUTUBE_DESCRIPTION" | translate }}</p>
            </div>
          </div>

          <div class="md:flex">
            <div class="md:w-full">
              <span class="font-medium"></span>
              <button class="btn bg-violet-600 hover:bg-violet-700 border-violet-600 hover:border-violet-700 text-white rounded-full mt-5">{{ "SETTINGS.PROFILE.SAVE_SOCIAL_PROFILE" | translate }}</button>
            </div>
          </div>
        </div>
      </div>
    </div><!--end grid-->
  </div><!--end container-->
</section><!--end section-->
<!-- End Hero -->
